{
  "GENERAL": {
    "CLOSE": "Затвори",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Търсене",
      "EMPTY_STATE": "Няма намерени резултати"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Необходими са поне {count}"
  }
}
